import script from "./TraitShopCartItem.vue?vue&type=script&setup=true&lang=js"
export * from "./TraitShopCartItem.vue?vue&type=script&setup=true&lang=js"

import "./TraitShopCartItem.vue?vue&type=style&index=0&id=dbea2960&lang=scss"

const __exports__ = script;

export default __exports__